<template>
	<div class="socials">
		<a
			v-for="medium in socials"
			:key="medium.ID"
			:class="medium.platform"
			:aria-label="medium.platform"
			:href="medium.url"
			target="_blank"
		>
			{{ medium.platform }}
		</a>
	</div>
</template>

<script setup>
defineProps({
	socials: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.socials {
	display: flex;
	align-items: center;
	place-content: center flex-start;

	a {
		color: var(--cta-color);
		line-height: 22px;
		font-size: 16px;
		font-weight: 700;
		text-decoration: none;

		&:hover {
			color: var(--cta-color-hover);
		}
	}
}

footer {
	.socials {
		flex-flow: column wrap;
		place-content: flex-start center;
		align-items: flex-start;
	}
}

.nav-contact {
	.socials {
		gap: 20px;

		a {
			color: var(--nav-color-dark);
			font-family: var(--heading-font-family);
			font-size: 24px;
			font-weight: 400;
			text-transform: capitalize;

			&:hover {
				color: #fff;
			}
		}
	}
}

@media (max-width: 880px) {
	.nav-contact {
		.socials {
			a {
				font-size: 20px;
			}
		}
	}
}

@media (max-width: 680px) {
	footer .socials {
		justify-content: center;
		margin: 0 0 20px;
	}

	.nav-contact {
		.socials {
			flex-flow: column wrap;
			gap: 8px;

			a {
				text-transform: uppercase;
			}
		}
	}
}
</style>
